<template>
  <form
    :aria-busy="loading ? 'true' : 'false'"
    :data-busy-message="dataBusyMessage"
    @submit.prevent="validateForm"
  >
    <fieldset>
      <div
        class="input-wrapper"
        :class="{'has-error': validation.errors.birthdate}"
      >
        <label for="birthdate">{{ 'birthdate' | translate }}</label>
        <input
          v-model="birthdate"
          v-mask="'##/##/####'"
          v-focus
          type="tel"
          name="birthdate"
          required
        >
        <div
          v-if="validation.errors.birthdate"
          class="error"
        >
          {{ validation.errors.birthdate }}
        </div>
      </div>
      <div
        class="input-wrapper"
        :class=" { 'has-error' : validation.errors.phone }"
      >
        <label for="phone">{{ 'phone' | translate }}</label>
        <input
          v-model="phone"
          v-mask="['(##) ####-####', '(##) #####-####']"
          type="tel"
          name="phone"
          placeholder="(00) 00000-0000"
          minlength="14"
          :required="paymentData.payment_method !== 'credit_card'"
        >
        <div
          v-if="validation.errors.phone"
          class="error"
        >
          {{ validation.errors.phone }}
        </div>
      </div>
      <div
        class="input-wrapper"
        :class="{'has-error' : validation.errors.zip_code }"
      >
        <label for="zip_code">{{ 'cep' | translate }}</label>
        <input
          ref="zipCode"
          v-model="zip_code"
          v-mask="'#####-###'"
          type="tel"
          name="zipcode"
          minlength="9"
          required
          @change="searchAddress($event)"
        >
        <div
          v-if="validation.errors.zip_code"
          class="error"
        >
          {{ validation.errors.zip_code }}
        </div>
      </div>
      <div
        class="input-wrapper"
        :class="{'has-error' : validation.errors.street }"
      >
        <label for="street">{{ 'street' | translate }}</label>
        <input
          ref="street"
          v-model="street"
          type="text"
          name="street"
          :disabled="true"
          required
        >
        <div
          v-if="validation.errors.street"
          class="error"
        >
          {{ validation.errors.street }}
        </div>
      </div>
      <div
        class="input-wrapper"
        :class="{'has-error' : validation.errors.number }"
      >
        <label for="number">{{ 'number' | translate }}</label>
        <input
          v-model="number"
          type="number"
          name="number"
          placeholder="apenas números ou deixar vazio"
          :required="!isTicket"
        >
        <div
          v-if="validation.errors.number"
          class="error"
        >
          {{ validation.errors.number }}
        </div>
      </div>
      <div
        class="input-wrapper"
        :class="{'has-error' : validation.errors.complement }"
      >
        <label for="complement">{{ 'complement' | translate }}</label>
        <input
          v-model="complement"
          type="text"
          name="complement"
          placeholder="Casa Fundos, apto. 1234"
          autocomplete="nope"
        >
        <div
          v-if="validation.errors.complement"
          class="error"
        >
          {{ validation.errors.complement }}
        </div>
      </div>
      <div
        class="input-wrapper"
        :class="{'has-error' : validation.errors.district }"
      >
        <label for="district">{{ 'district' | translate }}</label>
        <input
          ref="district"
          v-model="district"
          type="text"
          name="district"
          :disabled="true"
          required
        >
        <div
          v-if="validation.errors.district"
          class="error"
        >
          {{ validation.errors.district }}
        </div>
      </div>
      <div
        class="input-wrapper"
        :class="{'has-error' : validation.errors.city }"
      >
        <label for="city">{{ 'city' | translate }}</label>
        <input
          ref="city"
          v-model="city"
          type="text"
          name="city"
          :disabled="true"
          required
        >
        <div
          v-if="validation.errors.city"
          class="error"
        >
          {{ validation.errors.city }}
        </div>
      </div>
      <div
        class="input-wrapper"
        :class="{'has-error' : validation.errors.state }"
      >
        <label for="state">Estado</label>
        <select
          ref="state"
          v-model="state"
          type="text"
          name="state"
          :disabled="true"
          required
        >
          <option value="">
            Selecionar
          </option>
          <option
            v-for="(state, key) in states"
            :key="key"
            :value="key"
          >
            {{ state }}
          </option>
        </select>
        <div
          v-if="validation.errors.state"
          class="error"
        >
          {{ validation.errors.state }}
        </div>
      </div>
    </fieldset>
    <p
      v-if="errorMessage"
      class="error"
    >
      {{ errorMessage }}
    </p>
    <a
      class="donation-nav donation-nav--rewind"
      href="#"
      @click.prevent="goBack"
    >voltar</a>
    <button
      type="submit"
      :disabled="loading"
      class="donation-nav donation-nav--forward"
    >
      <template v-if="isTicket">
        Concluir
      </template>
      <template v-else>
        Continuar
      </template>
    </button>
  </form>
</template>

<script>
  import {
    mask
  } from 'vue-the-mask';
  import {
    validate,
    removeAccented
  } from '../../utilities';

  import { mapActions, mapMutations } from 'vuex'

  export default {
    name: 'AdressData',
    directives: {
      mask,
    },
    props:{
      isTicket: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        loading: false,
        dataBusyMessage: '',
        states: {
          AC: 'Acre',
          AL: 'Alagoas',
          AP: 'Amapá',
          AM: 'Amazonas',
          BA: 'Bahia',
          CE: 'Ceará',
          DF: 'Distrito Federal',
          ES: 'Espírito Santo',
          GO: 'Goiás',
          MA: 'Maranhão',
          MT: 'Mato Grosso',
          MS: 'Mato Grosso do Sul',
          MG: 'Minas Gerais',
          PR: 'Paraná',
          PB: 'Paraíba',
          PA: 'Pará',
          PE: 'Pernambuco',
          PI: 'Piauí',
          RJ: 'Rio de Janeiro',
          RN: 'Rio Grande do Norte',
          RS: 'Rio Grande do Sul',
          RO: 'Rondônia',
          RR: 'Roraima',
          SC: 'Santa Catarina',
          SE: 'Sergipe',
          SP: 'São Paulo',
          TO : 'Tocantins',
        },
        errorMessage: '',
        zip_code: '',
        state: '',
        city: '',
        street: '',
        district: '',
        number: '',
        complement: '',
        phone: '',
        birthdate: '',
        validation: {
          errors: {
          zip_code: '',
          state: '',
          city: '',
          street: '',
          district: '',
          },
        },
      };
    },
    computed: {
      paymentData() {
        return this.$store.state.paymentData;
      },
      iugu() {
        return this.$store.state.iugu;
      }
    },
    methods: {
      controlSession() {
      const data = {
        step: 'boleto',
      };
      const dataSession = JSON.parse(sessionStorage.getItem('doner-data'));
        if(dataSession != null){
          this.zip_code = dataSession.zip_code || this.zip_code;
          this.state = dataSession.state || this.state;
          this.city = dataSession.city || this.city;
          this.street = dataSession.street || this.street;
          this.district = dataSession.district || this.district;
          this.number = dataSession.number || this.number;
          this.complement = dataSession.complement || this.complement;
          this.birthdate = dataSession.birthdate
            ? dataSession.birthdate.split('-').reverse().join('/')
            : this.birthdate;
          this.phone = dataSession.phone || this.phone;
        }
      },
      goBack() {
        if (!this.isTicket) {
          this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'userData' });
        } else {
          this.SET_TICKET_STEP({ step: 'userData' });
        }
      },
      scrollToForm() {
        const form = this.isTicket
          ? document.getElementById('votar')
          : document.getElementById('doar');
        form.scrollIntoView({ block: 'start', behavior: 'smooth' });
      },

      toggleLoading(message = '') {
        this.loading = !this.loading;

        this.dataBusyMessage = this.dataBusyMessage !== message
          ? message
          : '';
      },

      validateForm() {
        this.toggleLoading('Validando endereço...');
        const birthdate = this.birthdate.split('/').reverse().join('-');

        const phone = this.phone
          ? this.phone.replace(/[^\d]+/g, "")
          : '';
        const address = {
          zip_code: this.zip_code,
          state: this.state,
          city: this.city,
          street: this.street,
          district: this.district,
          number: this.number,
          phone,
        };

        if (this.paymentData.payment_method === 'boleto' || this.isTicket) {
          address.birthdate = birthdate;
        }

        const validation = validate(address);

        if (validation.valid) {
          this.saveAddress();

          let donerData = {
            zip_code: this.zip_code,
            state: this.state,
            city: this.city,
            street: this.street,
            district: this.district,
            number: this.number,
            phone,
            birthdate,
          };

          let currentDonerData = sessionStorage.getItem('doner-data');

          if (currentDonerData) {
            currentDonerData = JSON.parse( currentDonerData );
            donerData = Object.assign( currentDonerData, donerData );
          }

          sessionStorage.setItem("doner-data", JSON.stringify( donerData ));
        } else {
          this.validation = validation;
          this.toggleLoading();
        }
      },

      saveAddress(){
        const payload = this.$store.state.paymentData;
        const phone = this.phone
          ? this.phone.replace(/[^\d]+/g, "")
          : '';

        payload.address_zipcode = this.zip_code;
        payload.address_state = this.state;
        payload.address_city = this.city;
        payload.address_street = this.street;
        payload.address_district = this.district;
        payload.address_house_number = this.number;
        payload.address_complement = this.complement;
        payload.phone = phone;

        let birthdate = this.birthdate.split('/');
        birthdate.reverse();
        birthdate = birthdate.join('-');
        payload.birthdate = birthdate;

        if (this.paymentData.payment_method === 'boleto' || this.isTicket) {
          payload.billing_address_zipcode = this.zip_code;
          payload.billing_address_state = this.state;
          payload.billing_address_city = this.city;
          payload.billing_address_street = this.street;
          payload.billing_address_district = this.district;
          payload.billing_address_house_number = this.number;
          payload.billing_address_complement = this.complement;
        }
        if (!this.isTicket) {
          this.$store.dispatch('GET_DONATION', payload)
            .then(res => {
              const stepToGoTo = this.paymentData.payment_method === 'credit_card'
                ? 'cardData'
                : 'certFaceVerify';

                this.handleIugu();

              this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: stepToGoTo });
            })
            .catch(err => {
              this.toggleLoading();
              this.handleErrorMessage(err);
            });
        } else {
          this.SEND_TICKET(payload)
            .then(res => {
              this.SET_TICKET_STEP({step: 'finalMessage'});
            })
            .catch(err => {
              this.handleErrorMessage(err);
            })
            .finally(err => {
              this.toggleLoading();
            });
        }
      },

      searchAddress(event){
        this.$data.validation.errors.zip_code = '';
        this.$data.validation.errors.state = '';
        this.$data.validation.errors.city = '';
        this.$data.validation.errors.street = '';
        this.$data.validation.errors.district = '';
        this.$data.state = '';
        this.$data.city = '';
        this.$data.street = '';
        this.$data.district = '';
        this.errorMessage = '';

        if(event.target.value.length !== parseInt(event.target.getAttribute('minlength'), 10)) {
          this.$data.validation.errors.zip_code = 'CEP inválido';

          return this.$refs.zipCode.select() || this.$refs.zipCode.focus();
        }

        this.toggleLoading('Procurando endereço...');

        this.$store.dispatch('getAddress', event.target.value).then((response) => {
          if (!response.state) {
            this.$refs.state.disabled = false;
          } else {
            this.$refs.state.disabled = true;
            this.state = response.state;
          }

          if (!response.city) {
            this.$refs.city.disabled = false;
          } else {
            this.$refs.city.disabled = true;
            this.city = response.city;
          }

          if (!response.street) {
            this.$refs.street.disabled = false;
          } else {
            this.$refs.street.disabled = true;
            this.street = response.street;
          }

          if (!response.district) {
            this.$refs.district.disabled = false;
          } else {
            this.$refs.district.disabled = true;
            this.district = response.district;
          }
          return this.toggleLoading();

        }).catch((error)=>{
          this.toggleLoading();
          if (error.response.status === 404) {
            this.$refs.state.disabled = true;
            this.$refs.city.disabled = true;
            this.$refs.street.disabled = true;
            this.$refs.district.disabled = true;

            this.$refs.zipCode.select() || this.$refs.zipCode.focus();

            return this.$data.validation.errors.zip_code = 'CEP não encontrado. Confira-o e preencha os campos restantes.';
          }

          this.$refs.state.disabled = false;
          this.$refs.city.disabled = false;
          this.$refs.street.disabled = false;
          this.$refs.district.disabled = false;

          this.$refs.zipCode.focus();

          if (error.response.data.form_error && error.response.data.form_error.CEP) {
              return this.$data.validation.errors.zip_code = error.response.data.form_error.CEP.indexOf('dismembered') !== -1
              ? 'Alguns endereços desse CEP mudaram. Por favor, confira o seu e preencha os campos restantes.'
              : error.response.data.form_error.CEP;
            } else {
              return this.$data.validation.errors.zip_code = error.response.data.form_error;
            }
        });

      },
      disableField(field) {
          this.$nextTick(function () {
          var element  = document.getElementsByName(field);
          element[0].disabled=false;
          return '';
          })

      },
      handleErrorMessage(err) {
        this.errorMessage = err.data[0].message;
      },
      handleIugu() {
        Iugu.setAccountID(this.iugu.account_id);
        Iugu.setTestMode(this.iugu.is_testing === 1 ? true : false);
      },

      ...mapActions([
        'SEND_TICKET',
      ]),

      ...mapMutations([
        'CHANGE_PAYMENT_STEP',
        'SET_TICKET_STEP',
      ]),
    },
    mounted() {
      this.scrollToForm();
      this.controlSession();
    },
  };
</script>



// WEBPACK FOOTER //
// _source/javascript/components/steps/addressData.vue